import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Popover } from '@mui';
import { makeStyles } from 'tss-react/mui';
import {
  calculateGanttBarWidth,
  calculateGanttBarStartWidth
} from '@utils/timeline-chart-utils';
import './timeline-chart.scss';

const useStyles = makeStyles()(() => ({
  popover: {
    pointerEvents: 'none'
  },
  paper: {
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    padding: 0,
    fontSize: '0.875rem',
    color: 'rgba(0, 0, 0, 0.87)'
  }
}));

const TimelineChartRow = ({ dateUnit, isSmall, minDate, popoverContent, row }) => {
  const agencyTypes = useSelector(state => state.dataTypes.agency_type);
  const { classes } = useStyles();
  const [anchorPosition, setAnchorPosition] = useState(null);

  const handleMouseEnter = useCallback(event => {
    setAnchorPosition({
      top: event.clientY,
      left: event.clientX
    });
  }, []);

  const handleMouseLeave = useCallback(() => {
    setAnchorPosition(null);
  }, []);

  const handleMouseMove = useCallback(event => {
    setAnchorPosition({
      top: event.clientY,
      left: event.clientX
    });
  }, []);

  const open = Boolean(anchorPosition);

  const isAllBar = isSmall && row.name === 'All';
  const spacerStyle = {
    width: calculateGanttBarStartWidth(row.start_date, minDate, dateUnit)
  };
  const rowColor = row.color || agencyTypes[row.agency_type] && agencyTypes[row.agency_type].color;
  const labelStyle = { color: rowColor };
  const barStyle = {
    backgroundColor: rowColor,
    opacity: 0.5,
    width: calculateGanttBarWidth(row.start_date, row.end_date, dateUnit)
  };
  const smallStyle = isSmall ? `timeline-chart-row-small${isAllBar ? '-all' : ''}` : '';
  const rowStyle = `timeline-chart-row ${smallStyle}`;

  return (
    <div styleName={rowStyle}>
      <div style={spacerStyle} />
      <div styleName="timeline-chart-row-container">
        {!isAllBar && (
          <div
            styleName="timeline-chart-row-label"
            style={labelStyle}
          >
            {row.name}
          </div>
        )}
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onMouseMove={handleMouseMove}
          role="presentation"
          styleName="timeline-chart-row-bar"
          style={barStyle}
        />
        <Popover
          className={classes.popover}
          classes={{ paper: classes.paper }}
          open={open}
          anchorReference="anchorPosition"
          anchorPosition={anchorPosition || { top: 0, left: 0 }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          disableRestoreFocus
        >
          {popoverContent(row)}
        </Popover>
      </div>
    </div>
  );
};

TimelineChartRow.propTypes = {
  dateUnit: PropTypes.number,
  isSmall: PropTypes.bool,
  minDate: PropTypes.object,
  popoverContent: PropTypes.func,
  row: PropTypes.object
};

export default TimelineChartRow;
